module.exports = __webpack_public_path__ + "img/20210904_114323.4cc14687.jpg";